module.exports = __webpack_public_path__ + "media/assets/images/safari-2a0c88566fa5c6ace702abb3594ceb5b.png";